import { NotificationStatus } from "@gtpl/shared-models/common-models";
import { ForkLiftJobStatus } from "@gtpl/shared-models/warehouse-management";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum } from "class-validator";

export class CreateNotification {    
    @ApiProperty()
    @IsNotEmpty()
    plantId: number;
    @ApiProperty()
    @IsNotEmpty()
    palletId: number;
    @ApiProperty()
    @IsNotEmpty()
    jobId: number;   
    @ApiProperty({enum:Object.values(NotificationStatus)})
    @IsNotEmpty()
    @IsEnum(NotificationStatus)
    status:NotificationStatus;   
    @ApiProperty()
    @IsNotEmpty()
    statusMessage: string;
    @ApiProperty()
    @IsNotEmpty()
    createdUser: string;     
  }